export default function Django_Syllabus() {
  return <div>Django_Syllabus Component</div>;
}
